import React from 'react';

import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Header, {headerItemsLabels} from '../../../Common/Header/header';
import CreatePartTypeDialog from './Dialogs/CreatePartTypeDialog/createPartTypeDialog';
import PartTypesViewGrid from './PartTypesViewGrid/partTypesViewGrid';
import {PL_DialogWrapper}  from 'infrastructure/js/components/Dialog/dialog';
import {MatSettingsMenuItemsIds} from '../../../../enums/navigationMenuItemsIds';
import {gridsNames} from '../../../../enums/gridsNames';
import {ImportAcceptFileTypes, ImportTypes} from '../../../../enums/importTypes';

export default class PartTypesView extends React.PureComponent {

  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.administration.matsettings.parttypes.view.');
  }

  componentDidMount() {
    this.props.actions.matSettingsPageActions.onSelectedMenuItemChanged(MatSettingsMenuItemsIds.NAV_ELEMENT_PART_TYPES);
  }

  getHeaderItems() {
    let {actions} = this.props;
    let hasRows = this.props.sHasRows;
    let selectedRowsData = this.props.sSelectedRowsData;

    return {
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
        },
        {
          id:'create',
          label: headerItemsLabels.CREATE,
          icon: 'pl pl-icon-add',
          action: actions.header.onCreatePartTypeClick,
        },
        {
          id:'edit',
          label: headerItemsLabels.EDIT,
          icon: 'pl pl-edit-icon',
           disabled: !(hasRows && selectedRowsData.size === 1),
          action: actions.header.onEditPartTypeClick,
          actionData: selectedRowsData.get(0)

        },
      ],

      kebab: {
        // disabled: !selectedRowsData || selectedRowsData.size === 0,
        menuItems: [
          {
            id: 'importPartTypes',
            label: headerItemsLabels.IMPORT_PART_TYPES,
            action: actions.header.importItems,
            disabled: false,
            actionData: {
              importTypes: [ImportTypes.IMPORT_PART_TYPES],
              acceptFileTypes: [ImportAcceptFileTypes.CSV],
              parentComponent: actions.reload
            }
          },
          {
            id: 'exportPartTypes',
            label: headerItemsLabels.EXPORT_PART_TYPES,
            action: actions.header.exportItems,
            disabled: !hasRows,
            actionData: { gridName: gridsNames.ADMINISTRATION_MAT_SETTINGS_PART_TYPES }
          },
          {
            id:'remove',
            label: headerItemsLabels.DELETE,
            action: actions.header.onRemovePartTypesClick,
            disabled: (!selectedRowsData || selectedRowsData.size === 0),
            actionData:  selectedRowsData,
          },

        ]
      }
    };
  }

  reloadPage = () => {
    this.props.actions.init(true);
  };



  render() {
    let title = this.labels.get('title');
    let headerItems = this.getHeaderItems();
    return (
      <div className="administration-view">
        <div className="title">{title}</div>

        <Header {...headerItems}/>

        <PartTypesViewGrid actions={{...this.props.actions.partTypesViewGridActions, ...this.props.actions.fetchEntitiesActions}} />

        <PL_DialogWrapper dialogComponent={CreatePartTypeDialog}
                          show={this.props.sCreatePartTypeDialogData.get('show')}
                          actions={this.props.actions.createPartTypeDialogActions}
                          sData={this.props.sCreatePartTypeDialogData}
                          reloadParentComponent={this.reloadPage}
        />
      </div>
    );
  }
}



